import { render, staticRenderFns } from "./staticErrorList.vue?vue&type=template&id=707dfb85&"
import script from "./staticErrorList.vue?vue&type=script&lang=js&"
export * from "./staticErrorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports